module.exports = __webpack_public_path__ + "img/aa-cf.bb8603b6.png";